import React from 'react'
import Modal from 'react-modal'
import renderHTML from 'react-render-html'
import accessibleIcon from '../../../../assets/icons/accessible-room.svg'
import informationIcon from '../../../../assets/icons/information-icon.svg'

const BkFlowRoomCardAdaDescriptionModal = props => {
	const {
		adaDisclaimer,
		hotelLabels,
		toggledState,
		toggleEvent
	} = props

	return (
		<div className="bk-flow-room__card-ada-description modal">
			<button
				className="u-txt-toggle-read-more u-font-small u-font-bold"
				onClick={ () => toggleEvent() }
			>
				<img
					className="accessible-icon"
					src={accessibleIcon}
					alt="Toggle Accessible Room Details"
				/>

				{ toggledState ?
					hotelLabels.readMoreAccessibleRooms ? hotelLabels.readMoreAccessibleRooms : 'Accessible Rooms'
				:
					hotelLabels.readMoreAccessibleRooms ? hotelLabels.readMoreAccessibleRooms : 'Accessible Rooms'
				}


				<img
					className="info-icon"
					src={informationIcon}
					alt="Toggle Accessible Room Details"
				/>
			</button>

			<Modal
				className={{
					base: 'bk-flow-room__card-ada-modal u-modal u-modal--sm',
					afterOpen: 'u-modal--visible',
					beforeClose: 'u-modal--close',
					ariaHideApp: false
				}}
				overlayClassName={{
					base: 'u-fade',
					afterOpen: 'u-fade--visible',
					beforeClose: 'u-fade--visible'
				}}
				isOpen={ toggledState }
				onRequestClose={ () => toggleEvent() }
				contentLabel="Accessible Room Modal"
				shouldCloseOnOverlayClick={ true }
				ariaHideApp={ false }
			>
				<div className="u-modal__header">
					<h5>{ hotelLabels.accesibleRoomDetails ? hotelLabels.accesibleRoomDetails : 'Accessible Room Details' }</h5>

					<div
						className="u-modal__close u-font-small u-font-bold"
						onClick={ () => toggleEvent() }
					>
						{ hotelLabels.close ? hotelLabels.close : 'Close' }
						<i className="material-icons">close</i>
					</div>
				</div>

				<div className="u-modal__body">
					{ renderHTML(adaDisclaimer) }
				</div>
			</Modal>
		</div>
	)
}

export default BkFlowRoomCardAdaDescriptionModal



// WEBPACK FOOTER //
// ./src/components/room/elements/accessiblity/BkFlowRoomCardAdaDescriptionModal.js